import React from 'react'
import { useTransitionState } from 'gatsby-plugin-transition-link/hooks'
import { useStaticQuery, graphql } from 'gatsby'
import { Helmet } from 'react-helmet'
import classNames from 'classnames'

import { Carousel } from '../../components/custom/Carousel'
import { HeroWave } from '../../components/custom/HeroWave'
import styles from './styles.module.scss'

export default function OnDemandPage({
  pageContext: { videos, descriptions },
}) {
  const convVideos = Object.entries(videos)
  const { transitionStatus } = useTransitionState()
  const isEntering = ['entering', 'entered'].includes(transitionStatus)
  const isExiting = ['exiting', 'exited'].includes(transitionStatus)

  const imgs = useStaticQuery(graphql`
    query {
      onDemandImg: file(relativePath: { eq: "working-out-laptop-2.jpg" }) {
        childImageSharp {
          fluid(maxHeight: 850, maxWidth: 1460, quality: 90) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  // Arbitrary order for on-demand categories
  const categorySorting = [
    'Strength',
    'Cardio',
    'Mind &amp; Body',
    'Meditation',
  ]
  const sortedVideos = categorySorting.flatMap((category) =>
    convVideos.filter(([videoKey]) => videoKey === category)
  )

  return (
    <div
      className={classNames(styles.wrapper, {
        [styles.isEntering]: isEntering,
        [styles.isExiting]: isExiting,
      })}
    >
      <Helmet>
        <title>On-Demand Classes</title>
        <meta
          name="description"
          content="
            Find on-demand fitness classes such as Zumba, Bootcamp Fitness or
            SilverSneakers, and a variety of educational workshops around
            nutrition and stress relief."
        />
      </Helmet>
      <HeroWave
        img={imgs.onDemandImg.childImageSharp.fluid}
        copy="Wellness videos at your fingertips"
      />
      <div className={styles.contentWrapper}>
        {sortedVideos.map((sortGroup, categoryIndex) => {
          const [category, categoryVideos] = sortGroup
          return (
            <Carousel
              key={category}
              name={category}
              description={descriptions[category]}
              index={categoryIndex}
              items={categoryVideos}
            />
          )
        })}
      </div>
    </div>
  )
}
